import './realtime_content_checker_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}


class Monitoring.Views.SocialContents.RealtimeReviewContentCheckerView extends Monitoring.Views.SocialContents.RealtimeContentCheckerView

  initialize: (@options = {}) ->
    super(@options)
    @batchSize = @options.batchSize

  notifyNewContent: (counter) =>
    @eventAggregator.trigger('onReviewCountUpdated', @dashboardUuid, counter)

  render: ->
    @restartTimeOut()
    return this

  getMinutesToWait: ->
    1

  setBatchSize: (size) =>
    @batchSize = size

  shouldUpdate: ->
    return @batchSize == 0